var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 42,
    height: 42,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.21 14.182c-2.992 0-5.417 2.442-5.417 5.454 0 1.532.626 2.916 1.636 3.907A9.276 9.276 0 009 32h18.42a9.278 9.278 0 00-5.428-8.458 5.455 5.455 0 001.636-3.906c0-3.012-2.425-5.454-5.418-5.454zM23.99 10a5.404 5.404 0 00-4.537 2.47 7.142 7.142 0 012.325.84 3.051 3.051 0 012.212-.946c1.695 0 3.07 1.383 3.07 3.09a3.093 3.093 0 01-1.757 2.795 7.358 7.358 0 01-.002 2.786c3.163.616 5.551 3.419 5.551 6.783H33.2a9.278 9.278 0 00-5.43-8.457 5.455 5.455 0 001.637-3.906c0-3.013-2.425-5.455-5.417-5.455z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgMediGroup;